import { setCookie, removeCookie } from "vue-app/utils/cookies";

export function saveUtmToCookies(): void {
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

  utmParams.forEach((param) => {
    const value = urlParams.get(param);
    if (value) {
      setCookie(param, value, 30);
    }
  });
}

export function removeUtmFromCookies(): void {
  const utmParams = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

  utmParams.forEach((param) => {
    removeCookie(param);
  });
}
